import React, { useContext, useState } from "react";

import AlertContext from "./AlertContext";

/**
 * 
 * @returns 
 */
export const useAlertContext = () => useContext(AlertContext);

/**
 * 
 * @param param0 
 * @returns 
 */
const AlertProvider = ({ children }) => {
    /**
     * 
     */
    const [showAlert, setShowAlert] = useState(false);

    /**
     * 
     */
    const [text, setText] = useState(undefined);

    /**
     * 
     */
    const [color, setColor] = useState('');

    /**
     * 
     */
    const toggleAlert = () => {
        setShowAlert(!showAlert);
    };

    /**
     * The store object
     */
    const state = {
        showAlert,
        text,
        color,
        setShowAlert,
        setText,
        setColor,
        toggleAlert
    };

    /**
     * Wrap the application in the provider with the initialized context
     */
    return <AlertContext.Provider value={state}>{children}</AlertContext.Provider>;
};

export default AlertProvider;
